<template>
  <div id="generalize">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/skillList' }">技能列表</el-breadcrumb-item>
      <el-breadcrumb-item>数据概览</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="echartsList">
      <p class="title">整体概况</p>
      <div class="generalizeCon">
        <ul>
          <li>
            <b>{{this.gen.user}}</b>
            <span>总用户量</span>
          </li>
          <li>
            <b>{{this.gen.interactive}}</b>
            <span>总交互次数</span>
          </li>
          <li>
            <b>{{this.gen.frequency}}</b>
            <span>人均交互次数</span>
          </li>
        </ul>
        </div>
      </div>
    <div class="echartsList2">
      <p class="title">整体趋势</p>
      <div class="generalizeCon">
        <div class="timeSelect">
          <template>
            <el-select v-model="timeDate" placeholder="请选择">
              <el-option label="最近3天" :value="3"></el-option>
              <el-option label="最近7天" :value="7"></el-option>
              <el-option label="最近30天" :value="30"></el-option>
            </el-select>
          </template>
          <el-button type="primary" class="little-btn" style="margin-left: 10px" round @click="personNum">查询</el-button>
        </div>
        <div id="echarts1" style="width:100%;height:500px;">
        </div>
    </div>
  </div>
    <div class="echartsList2">
      <p class="title">交互趋势</p>
      <div class="generalizeCon">
        <div class="timeSelect">
         <div style="margin-bottom:20px">
           <el-button type="default" class="little-btn" round @click="num(1)" :style="[numFlag == 1 ? {'background':'#409EFF','color':'#fff'}:null]">总交互次数</el-button>
           <el-button type="default" class="little-btn" round @click="num(2)" :style="[numFlag == 2 ? {'background':'#409EFF','color':'#fff'}:null]">人均交互次数</el-button>
         </div>
          <template>
            <el-select v-model="timeDate2" placeholder="请选择">
              <el-option label="最近3天" :value="3"></el-option>
              <el-option label="最近7天" :value="7"></el-option>
              <el-option label="最近30天" :value="30"></el-option>
            </el-select>
          </template>
          <el-button type="primary" class="little-btn" style="margin-left: 10px" round @click="int_or_ave">查询</el-button>
        </div>
        <div>
          <div id="echarts2" style="width:100%;height:500px">
        </div>
       <!--<div>-->
         <!--<div id="echarts3" style="width:100%;height:500px;">-->
       <!--</div>-->
       <!--</div>-->

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts'
  import 'echarts/theme/macarons'
  import qs from 'qs'
  import config from '@/config/index'
  import {getUserId, personNumApi, interactiveApi, averageApi, generalizeApi} from '@/api'
  export default {
    data() {
      return {
        timeDate: 3,
        timeDate2: 3,
        numFlag: 1,
        option: {
          title : {
            text: '用户总量/新增用户',
            subtext: ''
          },
          tooltip : {
            trigger: 'axis'
          },
          toolbox: {
            show : false,
            feature : {
              mark : {show: true},
              dataView : {show: true, readOnly: false},
              magicType : {show: true, type: ['line', 'bar']},
              restore : {show: true},
              saveAsImage : {show: true}
            }
          },
          calculable : true,
          xAxis : [
            {
              type : 'category',
              boundaryGap : false,
              data : []
            }
          ],
          yAxis : [
            {
              type : 'value',
              axisLabel : {
                formatter: '{value}'
              }
            }
          ],
          series : [
            {
              name:'用户总量',
              type:'line',
              data:[],
            }
          ]
        },
        option2: {
          title : {
            text: '交互日活',
            subtext: ''
          },
          tooltip : {
            trigger: 'axis'
          },
          toolbox: {
            show : false,
            feature : {
              mark : {show: true},
              dataView : {show: true, readOnly: false},
              magicType : {show: true, type: ['line', 'bar']},
              restore : {show: true},
              saveAsImage : {show: true}
            }
          },
          calculable : true,
          xAxis : [
            {
              type : 'category',
              boundaryGap : false,
              data : []
            }
          ],
          yAxis : [
            {
              type : 'value',
              axisLabel : {
                formatter: '{value}'
              }
            }
          ],
          series : [
            {
              name:'交互次数',
              type:'line',
              data:[],
            }
          ]
        },
        option3: {
          title : {
            text: '交互日活',
            subtext: ''
          },
          tooltip : {
            trigger: 'axis'
          },
          toolbox: {
            show : false,
            feature : {
              mark : {show: true},
              dataView : {show: true, readOnly: false},
              magicType : {show: true, type: ['line', 'bar']},
              restore : {show: true},
              saveAsImage : {show: true}
            }
          },
          calculable : true,
          xAxis : [
            {
              type : 'category',
              boundaryGap : false,
              data : []
            }
          ],
          yAxis : [
            {
              type : 'value',
              axisLabel : {
                formatter: '{value}'
              }
            }
          ],
          series : [
            {
              name:'交互次数',
              type:'line',
              data:[],
            }
          ]
        },
        gen: {
          user: 0,
          interactive: 0,
          frequency: 0
        }
      }

    },
    created () {
      this.personNum()
      this.interactive()
      this.generalize()
    },
    methods: {
      async generalize () {
        let data = {
          skill_id: this.$route.query.skillId
        }
        let res = await generalizeApi(qs.stringify(data))
        if (res.data.code == 200) {
          this.gen = res.data.data[0]
        } else {
          this.$message.error('当前网络状况异常，请稍后再试')
        }
      },
      async personNum () {
        let data = {
          skill_id: this.$route.query.skillId,
          date: this.timeDate
        }
        let res = await personNumApi(qs.stringify(data))
        if (res.data.code == 200) {
          this.option.xAxis[0].data = res.data.data[0].date
          this.option.series[0].data = res.data.data[0].data
          window.eac.setOption(this.option)
        } else {
          this.$message.error('当前网络状况异常，请稍后再试')
        }

      },
      async interactive () {
        let data = {
          skill_id: 'asdf',
          date: this.timeDate2
        }
        let res = await interactiveApi(qs.stringify(data))
        if (res.data.code == 200) {
          this.option2.xAxis[0].data = res.data.data[0].date
          this.option2.series[0].data = res.data.data[0].data
          console.log(this.option2)
          window.eac2.setOption(this.option2)
        } else {
          this.$message.error('获取数据失败')
        }

      },
      async average () {
        let data = {
          skill_id: 'asdf',
          date: this.timeDate2
        }
        let res = await averageApi(qs.stringify(data))
        if (res.data.code == 200) {
          console.log(this.option3.xAxis[0].data);
          this.option3.xAxis[0].data = res.data.data[0].date
          this.option3.series[0].data = res.data.data[0].data
          window.eac2.setOption(this.option3)
        } else {
          this.$message.error('获取数据失败')
        }

      },
       num (num) {
        if (num == 1) {
          this.numFlag = 1
          this.interactive()
        } else if (num == 2) {
          this.numFlag = 2
          this.average()
        }
      },
      int_or_ave () {
        if (this.numFlag == 1) {
          this.interactive()
        }else if (this.numFlag == 2) {
          this.average()
        }
      }
    },
    mounted () {
      window.eac = echarts.init(document.getElementById('echarts1'), 'macarons')
      window.eac2 = echarts.init(document.getElementById('echarts2'), 'macarons')
//      window.eac3 = echarts.init(document.getElementById('echarts3'), 'macarons')
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">
  #generalize {
    padding-top:0;
    background:#f9f9f9;
    width: 100%;
    height:100%;
    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 18px;
      font-weight: 900;
      color: #2e4d79;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
      background:#fff;
      margin-bottom:0;
    }
    .generalizeCon{
      background:#fff;
      padding:25px 0 20px 30px;
      .timeSelect{
        margin-bottom:20px;
        .el-input--suffix .el-input__inner{
          height: 28px;
          line-height: 28px;
          width: 108px;
          border-radius:20px;
        }
      }

      ul{
        width: 100%;
        list-style: none;
        display: flex;
        li{
          flex:1;
          text-align: center;
          b{
            display: block;
            font-size: 48px;
          }
        }
      }
    }
    .little-btn{
      height: 28px;
      padding-top: 0;
      padding-bottom: 0;
      line-height: 28px;
    }
    .echartsList2{
      margin-top:20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/skilloverview/GeneralizeData.vue